import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  LegalDocumentContent,
  LEGAL_DOCUMENTS,
  LegalDocKind,
  PRIVACY_POLICY_URL,
} from '@shared/ui/legal-consent';

/*
 * Публичная страница текста согласия (без входа): /consent/personal-data и
 * /consent/marketing. Согласие — отдельный документ со своей страницей
 * (152-ФЗ в ред. 156-ФЗ); на неё же могут ссылаться мобильные приложения.
 */
const LegalDocumentPage: React.FC<{ kind: LegalDocKind }> = ({ kind }) => {
  const doc = LEGAL_DOCUMENTS[kind];
  useEffect(() => {
    document.title = doc.title;
  }, [doc.title]);

  return (
    <div className="min-h-screen bg-[#f5f6f8] py-10 px-4">
      <article className="mx-auto max-w-[820px] bg-white rounded-xl shadow-sm px-6 sm:px-10 py-8">
        <h1 className="text-2xl font-bold text-[#2d2c2c] leading-tight mb-6">{doc.title}</h1>
        <LegalDocumentContent kind={kind} />
        <div className="mt-8 pt-6 border-t border-gray-100 flex flex-wrap gap-x-6 gap-y-2 text-sm">
          <a
            href={PRIVACY_POLICY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#e3282a] underline"
          >
            Политика обработки персональных данных
          </a>
          <Link to="/login" className="text-gray-500 underline">
            Вернуться в личный кабинет
          </Link>
        </div>
      </article>
    </div>
  );
};

export default LegalDocumentPage;
